<template>
  <input ref="file" type="file" :name="name" class="input-file" :placeholder="placeholder">
</template>
<script>
  export default {
    name: 'input-file',
    props: {
      name: {
        type: String,
        default: function () {
          return 'file'
        }
      },
      value: {
        type: Array,
        default: function () {
          return []
        }
      },
      options: {
        type: Object,
        default: function () {
          return {}
        }
      },
      auth: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      category: {
        type: String,
        default: function () {
          return ''
        }
      },
      section: {
        type: String,
        default: function () {
          return ''
        }
      },
      placeholder: {
        type: String,
        default: function () {
          return ''
        }
      },
      theme: {
        type: String,
        default: function () {
          return 'default-theme'
        }
      },
      multiple: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      autoUpload: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      limited: {
        type: Number,
        default: function () {
          return 10
        }
      },
      rotate: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      preview: {
        type: Boolean,
        default: function () {
          return false
        }
      },
      dataUrl: {
        type: String,
        default: function () {
          return `${location.protocol}//${location.hostname}`
        }
      },
      saveUrl: {
        type: String,
        default: function () {
          return ''
        }
      },
      removeUrl: {
        type: String,
        default: function () {
          return ''
        }
      },
    },
    data: function () {
      return {
        tmpFileCnt: 0,
        fileList: [],
        defaultOptions: {
          localization: {
            select: '파일찾기',
            cancel: '취소',
            clearSelectedFiles: '파일 삭제',
            dropFilesHere: '여기에 파일을 Drag&Drop',
            headerStatusUploaded: '업로드 되었습니다',
            headerStatusUploading: '업로드 중입니다',
            invalidFileExtension: '잘못된 파일형식 입니다',
            invalidFiles: '잘못된 파일입니다',
            invalidMaxFileSize: '파일 최대크기를 초과하였습니다',
            invalidMinFileSize: '파일 최소크기보다 작습니다',
            remove: '삭제',
            retry: '재시도',
            statusFailed: '실패',
            statusUploaded: '업로드',
            statusUploading: '업로드 중',
            uploadSelectedFiles: '선택된 파일을 업로드'
          },
          multiple: this.multiple,
          async: {
            saveUrl: '/api/file/?section=' + this.section + '&category=' + this.category,
            removeUrl: '/api/file/delete/',
            autoUpload: this.autoUpload,
            removeField: 'filename'
          },
          // template: '<div> hello! </div>',
          files: [],
          select: this.onSelect,
          upload: this.onUpload,
          remove: this.onRemove,
          success: this.onSuccess,
          error: this.onError,
          validation: {
            allowedExtensions: ['.txt', '.xls', '.xlsx', '.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,     // 5MB
            minFileSize: 0
          }
        }
      }
    },
    watch: {
      'value': {
        handler: function (val) {
          this.fileList = val
        },
        deep: true
      }
    },
    methods: {
      init: function () {
        const vm = this
        const element = vm.$el
        const fileList = $.extend(true, [], vm.value)

        // 저장된 파일이 있을 경우
        if (fileList.length > 0) {
          vm.tmpFileCnt = fileList.length
          for (let i in fileList) {
            const data = fileList[i]
            const filename = data.name.split('/').pop(-1)
            const extension = '.' + filename.split('.').pop(-1)
            const info = {
              id: data['id'],
              uid: data['uid'],
              size: data['size'],
              origin_name: data['origin_name'],
              name: data['name'],
              extension: extension,
              datafile: data['datafile'],
              deg: data['deg']
            }

            // 파일목록에 파일 정보를 담는다.
            vm.fileList[i] = info
          }
          // 파일 목록을 기본값으로 설정한다.
          vm.defaultOptions['files'] = vm.fileList
        }

        // 저장 URL 값이 있을 경우
        if (vm.saveUrl) {
          vm.defaultOptions.async['saveUrl'] = vm.saveUrl
        }

        // 삭제 URL 값이 있을 경우
        if (vm.removeUrl) {
          vm.defaultOptions.async['removeUrl'] = vm.removeUrl
        }

        // 설정값 병합하기
        Object.assign(vm.defaultOptions, vm.options)

        // 파일업로드 초기화
        $(element).kendoUpload(vm.defaultOptions)

        // 초기화 이후
        vm.$nextTick(function () {
          // 저장된 파일이 있을 경우, 파일을 여는 Event를 설정해준다.
          if (vm.fileList.length > 0) {
            vm.findFileName('load', vm.fileList)
            // 프리뷰 옵션이 활성화 되어 있을 경우, 이미지 프리뷰를 만들어준다.
            if (vm.preview) {
              vm.addPreview(vm.fileList, true)
            }
          }
          // placeholder 옵션이 설정되었을 경우, 엘리먼트를 생성하여 붙여준다.
          if (vm.placeholder) {
            const template = '<em style="display: block; color: #ccc; font-size: 14px; font-style: normal; font-stretch: normal; font-weight: normal;">' + vm.placeholder + '</em>'
            $('.k-dropzone').append(template)
          }
        })
      },
      rotation: function (e) {
        const uid = e.target.id.replace('rotation_', '')
        // transform 의 css 를 가져오면 matrix 값이 나와서 별도의 attr 에 각도 값을 넣어주고 저장한다..
        let deg = parseInt($('#' + uid).attr('deg'))
        if (deg) {
          deg = (deg + 90) % 360
        } else {
          deg = 90
        }
        $('#' + uid).css('transform', 'rotate(' + deg + 'deg)')
        $('#' + uid).attr('deg', deg)

        // 현재 선택된 파일데이터에 Rotation 값을 업데이트 한다.
        if (_.find(this.fileList, ['uid', uid])) {
          _.find(this.fileList, ['uid', uid]).deg = deg
          // 부모에게 값을 전달한다.
          this.$emit('input', this.fileList)
        }
      },
      addPreview: function (files, saved) {
        // 사진이 업로드 되었을 경우에만 미리보기 활성화 (선택항목에는 미리보기 지원을 안함)
        if (saved) {
          for (let i in files) {
            // deg 값이 없을 경우, 0을 기본값으로 설정해준다.
            const deg = typeof files[i].deg === 'undefined' ? 0 : files[i].deg
            // 미리보기와 회전 이미지를 붙일 Target Element
            const target = $('span[uid="' + files[i].uid + '"]').parent().parent().children('.k-file-extension-wrapper')
            // 미리보기 이미지 Elemnet
            const preview = "<img class='image-preview' src='" + files[i].datafile + "' id='" + files[i].uid +
              "' deg='" + deg + "' style=transform:rotate(" + deg + "deg)>"
            // 회전 이미지 Elemnet
            const rtt = "<img src='s/assets/img/rotation.png' width='24' height='24' style='cursor: pointer;' id='rotation_" + files[i].uid + "')>"

            // 이미지 회전 옵션을 사용 할 경우
            if (this.rotate) {
              target.replaceWith(preview + rtt)
              // 이미지 회전 옵션을 사용 할 경우, 미리보기 + 회전 이미지를 넣어 이벤트를 걸어준다.
              const rtt2 = document.querySelector('img[id="rotation_'+ files[i].uid +'"]')
              if (rtt2) {
                rtt2.addEventListener('click', this.rotation)
              }
            } else {
              // 회전 옵션을 사용하지 않을 경우, 미리보기 이미지만 넣어준다.
              target.replaceWith(preview)
            }
          }
        }
        // 선택만 되고 업로드 되지 않은 이미지에 대한 미리보기 코드
        // else {
        //   for (let i in files) {
        //     const raw = files[i].rawFile
        //     const reader = new FileReader()
        //     if (raw) {
        //       reader.onloadend = function () {
        //         const preview = "<img class='image-preview' src='" + this.result + "'>"
        //         const target = $('li[data-uid="' + files[i].uid + '"] .k-file-extension-wrapper')
        //         target.replaceWith(preview)
        //       }
        //       reader.readAsDataURL(raw)
        //     }
        //   }
        // }
      },
      onSelect: function (e) {
        const vm = this
        const isMultiple = vm.multiple
        const limited = vm.limited
        // tmpFileCnt : (추가한 파일 + 또 추가한 파일)
        const len = vm.tmpFileCnt + e.files.length
        // const len = vm.fileList.length + e.files.length

        // 멀티업로드 옵션이 활성화 되었을 경우
        if (isMultiple) {
          // 현재 선택된 파일에 갯수가 설정된 제한갯수보다 많을 경우
          if (limited < len) {
            e.preventDefault()
            alert('최대 ' +  limited +  '개까지만 업로드 가능합니다.')
            return
          } else {
            vm.tmpFileCnt += e.files.length
          }
        }

        // 프리뷰 옵션이 활성화 되어 있을 경우, 이미지 프리뷰를 만들어준다.
        if (vm.preview) {
          const fileInfo = e.files
          vm.addPreview(fileInfo, false)
        }
      },
      onUpload: function (e) {
        const vm = this
        const isAuth = vm.auth
        const isMultiple = vm.multiple
        const limit = vm.limited
        const len = vm.fileList.length
        // 권한 옵션이 활성화 일 경우
        if (isAuth) {
          const xhr = e.XMLHttpRequest
          const token = localStorage.getItem('_t')
          // request Header Token Set
          xhr.addEventListener('readystatechange', function(e) {
            if (xhr.readyState === 1) {
              xhr.setRequestHeader('Authorization', 'JWT ' + token)
            }
          })
        }

        // 파일 uid Set
        e.data = { 'uid': e.files[0].uid }

        // 멀티업로드 옵션이 활성화 되었을 경우
        if (isMultiple) {
          // 최대 파일 업로드 갯수보다 파일수가 많을 경우
          if (limit <= len) {
            e.preventDefault()
            alert('최대 ' +  limit +  '개까지만 업로드 가능합니다.')
          }
        }
      },
      onRemove: function (e) {
        // 삭제 할 파일정보를 넣어준다.
        e.data = {
          id: e.files[0].id,
          uid: e.files[0].uid
        }
        const vm = this
        vm.tmpFileCnt -= 1
      },
      onSuccess: function (e) {
        const vm = this
        const files = e.files
        const operation = e.operation
        const response = e.response

        // 업로드에 성공했을 경우
        if (operation === 'upload') {
          const decodeName = decodeURI(response.datafile.split('/').pop(-1))
          const info = {
            id: response['id'],
            uid: files[0].uid,
            origin_name: files[0].name,
            name: decodeName,
            size: files[0].size,
            extension: files[0].extension,
            datafile: response.datafile,
            deg: 0
          }
          // 파일목록 업데이트
          vm.fileList.push(info)
          // 파일이 업로드 된 후 파일명을 클릭 할 경우 브라우져로 파일내용을 open
          vm.findFileName('add', info)

          if (vm.preview) {
            vm.addPreview(vm.fileList, true)
          }
        }

        // 삭제에 성공했을 경우
        if (operation === 'remove') {
          // 삭제된 파일정보에 ID가 있을 경우, ID값을 참조하여 지워준다.
          if (typeof e.files[0].id !== 'undefined') {
            vm.fileList = _.remove(vm.fileList, function (item) {
              return item.id !== e.files[0].id
            })
          } else {
            // ID 값이 없을 경우, UID 값을 참조하여 지워준다.
            vm.fileList = _.remove(vm.fileList, function (item) {
              return item.uid !== e.files[0].uid
            })
          }
        }

        // 부모에게 값을 전달한다.
        vm.$emit('input', vm.fileList)
      },
      onError: function (e) {
        const status = e.XMLHttpRequest['status']
        const text = e.XMLHttpRequest['statusText']
        console.log('file Upload error', status, text)
      },
      onDownload: function () {
        const url = event.target.getAttribute('data-url')
        const filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0]
        const xhr = new XMLHttpRequest()

        xhr.responseType = 'blob'
        xhr.onload = function () {
          const a = document.createElement('a')
          a.href = window.URL.createObjectURL(xhr.response) // xhr.response is a blob
          a.download = filename // Set the file name.
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
        xhr.open('GET', url)
        xhr.send()
        // window.open(url, '_blank')
      },
      previewFiles: function () {
        const previewUrl = this.dataUrl
        const dataUrl = event.target.getAttribute('data-url')
        let url = ''

        // data-url에 기본 URL이 있을 경우
        if (dataUrl.indexOf('http') !== -1) {
          url = dataUrl
        } else {
          url = previewUrl + dataUrl
        }

        if (url.match(/\.(tif|tiff)$/)? true : false) {
          /* tiff js load 후 실행 */
          $.getScript('/static/libs/js/tiff.min.js', function () {
            var w = window.open('')
            var doc = w.document
            var $loading = $("<div id='loading'>잠시만 기다려주세요...</div>")
            $(doc.body).append($loading)
            w.document.close()

            Tiff.initialize({TOTAL_MEMORY: 16777216 * 10})
            var xhr = new XMLHttpRequest()
            xhr.open('GET', url)
            xhr.responseType = 'arraybuffer'

            xhr.onload = function (e) {
              var buffer = xhr.response
              var tiff = new Tiff({buffer: buffer})

              for (var i = 0, len = tiff.countDirectory(); i < len; ++i) {
                tiff.setDirectory(i)
                var canvas = tiff.toCanvas()
                $(canvas).css({'width': '80%'})
                $(doc.body).append(canvas)
              }
              $loading.remove()
            }
            xhr.send()
          })
        } else {
          window.open(url)
        }
      },
      findFileName: function (type, data) {
        // 파일을 새로 업로드 했을 경우
        if (type === 'add') {
          // 업로드에 성공 할 경우 할당받는 UID를 찾아 이벤트를 등록한다.
          const target = document.querySelector('li[data-uid="' + data.uid + '"]')
          const file = target.querySelector('span[class="k-file-name"]')
          const path = data['datafile']

          // response에 uid 값을 이용해 현재 등록된 input-file을 찾아 download-Url을 setting
          file.setAttribute('data-url', path)
          file.setAttribute('uid', data.uid)
          file.addEventListener('click', this.previewFiles)
        } else {
          for (let i in data) {
            // 저장된 파일일 경우, 랜덤으로 할당받은 파일명을 찾아 이벤트를 등록한다.
            const info = data[i]
            const file = document.querySelector('span[title="' + info.name + '"]')
            // response에 name 값을 이용해 현재 불러온 input-file을 찾아 download-Url을 setting
            file.setAttribute('data-url', info.datafile)
            file.setAttribute('uid', info.uid)
            file.addEventListener('click', this.previewFiles)
          }
        }
      }
    },
    created: function () {
    },
    mounted: function () {
      // kendo Upload 초기화
      this.init()
    }
  }
</script>

<style lang="scss">
  .k-upload {
    border: 1px solid $border-color;
    border-radius: 4px;
    background-color: $hzc-white;

    .k-dropzone {
      text-align: right;

      .k-upload-status {
        float: left;
        margin-left: 8px;
        margin-top: 15px;
      }

      em {
        float: left;
        margin-left: 8px;
        margin-top: 5px;
        color: #a1a1a1 !important;
      }
    }

    .k-upload-files {
      padding: 0;
    }

    .k-upload-button, .k-clear-selected {
      display: inline-block;
      margin: 0;
      background-color: #f7f8fc;
      color: $font-color;
      text-align: center;
      outline: none;
      cursor: pointer;
      position: relative;
      white-space: nowrap;
      text-decoration: none;
      border-width: 1px;
      border-style: solid;
      border-color: $border-color;
      border-radius: 4px;
      box-shadow: 0 1px 1px 0 rgba(206, 212, 218, 0.32);
      font-weight: bold;

      &:hover {
        background-color: darken($hzc-white, 10%);
        color: $font-color;
        border-color: darken($border-color, 10%);
        text-decoration: none;
      }
      &:active {
        background-color: darken($hzc-white, 20%);
        border-color: darken($border-color, 10%);
        color: $font-color;
      }
      &:focus {
        color: $font-color;
        border-color: darken($border-color, 10%);
        text-decoration: none;

      }
    }

    .k-clear-selected {
      border: 0;
    }

    .k-upload-selected {
      display: inline-block;
      margin: 0;
      background-color: $primary-color-v2;
      color: $hzc-white;
      text-align: center;
      border: 0;
      outline: none;
      cursor: pointer;
      position: relative;
      white-space: nowrap;
      text-decoration: none;
      border: 0;
      border-radius: 0;
      &:hover {
        background-color: darken($primary-color-v2, 10%);
        color: $hzc-white;
        text-decoration: none;
      }
      &:active {
        background-color: darken($primary-color-v2, 20%);
        color: $hzc-white;
      }
      &:focus {
        color: $hzc-white;
        text-decoration: none;
      }
    }

    .k-file {
      padding: 8px;
    }

    .k-file-name {
      max-width: 12em;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  /* 파일업로드 컴포넌트를 md-size(32px)로 사용하기 위해 input-md-wrap 클래스를 사용한다. */
  .input-md-wrap {
    .k-dropzone {
      padding: 0;
    }
    .k-upload-button {
      border-width: 0 0 0 1px;
    }
  }

  .image-preview {
    position: relative;
    vertical-align: top;
    height: 40px;
    width: 40px;
  }
</style>



// WEBPACK FOOTER //
// ../common/components/InputFile.vue